import { render, staticRenderFns } from "./StudentRestore.vue?vue&type=template&id=e273e1e6"
import script from "@/controllers/student/student-restore.js?vue&type=script&lang=js&external"
export * from "@/controllers/student/student-restore.js?vue&type=script&lang=js&external"
import style0 from "./StudentRestore.vue?vue&type=style&index=0&id=e273e1e6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports